<template>
  <div class="chat-item__author-avatar">
    <div
      v-if="hasUserPicture && mediaImageUrl"
      class="image-profile"
    >
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 174 200">
        <defs>
          <pattern
            :id="`img#${user.id + hash}`"
            patternUnits="userSpaceOnUse"
            width="174"
            height="200"
          >
            <image
              :xlink:href="mediaImageUrl"
              x="0"
              y="0"
              width="174"
              height="200"
            />
          </pattern>
        </defs>
        <circle
          :fill="`url(#img#${user.id + hash})`"
          stroke="none"
          r="83.17853"
          cy="99.81251"
          cx="87"
        />
      </svg>
    </div>
    <div
      v-else
      class="image-profile pin--image"
    >
      <RoundedImage :text="getUserShortName(user)" />
    </div>
  </div>
</template>

<script>
import { checkThenGetImageUrl } from '@tools/media-image';
import RoundedImage from '@components/RoundedImage.vue';
import { messagingMixins } from '@pages/inbox/mixins';

export default {
  name: 'DealTimelineMessageAvatar',
  components: { RoundedImage },
  mixins: [ messagingMixins ],
  props: {
    user: { type: Object, required: true },
  },
  data() {
    return {
      hash: Math.floor(Math.random() * 100000),
      mediaImageUrl: null,
    };
  },
  computed: {
    hasUserPicture() {
      return this.user.picture_url || this.user.profile_picture;
    },
  },
  async mounted() {
    if (this.user.picture_url) {
      this.mediaImageUrl = this.user.picture_url;
    }

    if (this.user.profile_picture) {
      this.mediaImageUrl = await checkThenGetImageUrl(this.user.profile_picture.uuid, 'webp', 90, null, [ 90, 105 ], [ 1, 1 ]);
    }
  },
};
</script>
